<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div  class="loading_custom" v-if="is_show_progress" >
         <ProgressBar :value="progress" style="width:300px;" />
      </div>
      <div class="card card-w-title">
        <div class="doc-header doc-title">
          <strong>{{ title }}</strong>
          <!--          <Button label="Xuất mã barcode" class="p-button-sm export-barcode" :disabled="selectedRows == null || selectedRows.length == 0" @click="onExportExcelBarcode" v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.list_document.export == true || this.$store.getters.role == 'admin'"/>-->
          <!--          &lt;!&ndash; <Button label="Xuất mã barcode" class="p-button-sm export-barcode" :disabled="selectedRows == null || selectedRows.length == 0" @click="onExportBarcode" v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.list_document.export == true || this.$store.getters.role == 'admin'"/> &ndash;&gt;-->
          <!-- <div class="box-selected-file">
            <input type="file" name="exportFile" class="file" @change="onExportExcel"/>
            <span class="btn-span">Xuất</span>
          </div> -->
          <!--class="box-selected-file"-->
          <div  class="p-col-12" style="text-align: right;" ><!--v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.list_document.export == true || this.$store.getters.role == 'admin'"-->
            <!--<ExportExcel
              :fields="exportConfigs.fields"
              :fetch="exportConfigs.fetch"
              :colHeaderStyle="exportConfigs.colHeaderStyle"
              :name="exportConfigs.name"
              :key="refreshExport"
            >
              <span class="btn-span">Xuất</span>
            </ExportExcel>-->
            <Button v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.list_document.delete_group == true || this.$store.getters.role == 'admin'"  label="Xóa nhóm văn bản" class="p-button-warning style-btn-header delete_multiple_docs"  @click="popupDeleteDosc()"/>
            <Button  label="Xuất các dòng barecode đang chọn" v-if="this.$store.getters.role != 'court' && (this.$store.getters.group_permission && this.$store.getters.group_permission.list_document.export == true || this.$store.getters.role == 'admin' )" :disabled="selectedRows == null || selectedRows.length == 0" class="p-button-raised style-btn-header"  @click="onExportExcelBarcodeService(2)"/>
            <Button  label="Xuất tất cả mã barcode" v-if="this.$store.getters.role != 'court' && (this.$store.getters.group_permission && this.$store.getters.group_permission.list_document.export == true || this.$store.getters.role == 'admin')"  class="p-button-raised style-btn-header"  @click="onExportExcelBarcodeService(1)"/>
            <Button v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.list_document.export == true || this.$store.getters.role == 'admin'" label="Xuất các dòng đang chọn" :disabled="selectedRows == null || selectedRows.length == 0" class="p-button-raised style-btn-header"  @click="export_excel_document(2)"/>
            <Button v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.list_document.export == true || this.$store.getters.role == 'admin'" label="Xuất tất cả" class="p-button-raised style-btn-header"  @click="export_excel_document(1)"/>
          </div>
          <div  class="p-col-12" style="text-align: right;" >
            <Button style="margin: 0px 2px"  label="Tìm kiếm" icon="pi pi-search"  @click="onFilterData" />
            <Button style="margin: 0px 2px"  label="Clear" class="p-button-danger" @click="clearFilterData" />
<!--            <Button style="margin: 0px 2px" icon="pi pi-search" class="p-button-info" @click="onFilterData" />
            <Button style="margin: 0px 2px" icon="pi pi-times"  class="p-button-danger" @click="clearFilterData" />-->
          </div>
        </div>
        <!--:value="listData"-->
        <DataTable
            :value="listDataService"
            :lazy="true"
            class="p-datatable-responsive"
            dataKey="id"
            @page="onPage($event)"
            :selection.sync="selectedRows"
            :paginator="pagination"
            :totalRecords="totalDataChange"
            :rows="paginationRows"
            :first="firstRecordIndex"
            :loading="loading"
            :filters="filters"
            :scrollable="(scrollHeight !== '' ? true : false) "
            :scrollHeight="scrollHeight"
            :autoLayout="true"
            :key="componentKey"
            :rowClass="rowClass"
            filterMatchMode="startsWith"
            :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS" 
            :currentPageReportTemplate="''"

            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
<!--          :currentPageReportTemplate="'Tổng số văn bản: {totalRecords}       Tổng tiền:{rows} '"-->
          <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
          <!--v-for="c in dataModel.getDisplayFields()"-->
          <Column
              v-for="c in listColumns"
              :key="c.key"
              :field="getField(c)"
              :header="getLabel(c)"
              :filterMatchMode="getFilterMatch(c)"
              :filterFunction="customFilter"
              :sortable="getSortable(c)"
              :bodyClass="(c.class ? 'txt-' + c.class : '')"
              :bodyStyle="getHeaderStyle(c)"
              :headerStyle="getHeaderStyle(c)"
              :headerClass="(c.class ? 'txt-' + c.class : '')"
          >
            <template #body="slotProps">
              <img
                  v-if="getType(c) == 'Image'"
                  :src="getData(c, slotProps.data)"
                  style="width: 40px; heigth: 40px"
              />
              <div
                  v-else-if="c.type == 'Text'"
                  v-html="getData(c, slotProps.data)"
                  :style="(c.style ? c.style : '')"
              ></div>
              <div
                  v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
                  v-html="getData(c, slotProps.data)"
                  :style="(c.style ? c.style : '')"
              ></div>

              <Checkbox
                  v-else-if="getType(c) == 'Checkbox'"
                  v-model="slotProps.data[slotProps.column.field]"
                  :binary="true"
                  @change="onInputChange($event, slotProps.data, c)"
              />
              <div v-else>
                <div v-if="c.custom">
                  <!--<Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge"  />-->
                  <span v-if="c.custom == 'SelectionText'">{{ callbackDataSelect(c ,slotProps.data) }}</span>
                </div>
                <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
              </div>

            </template>
            <template v-if="c.filter" #filter>
              <InputText
                  v-if="c.filter.type == 'input'"
                  :type="c.filter.inputType ? c.filter.inputType : 'text'"
                  v-model="filters[c.key]"
                  class="p-column-filter"
                  :placeholder="getFilterPlaceHolder(c)"
                  @keyup="onFilter($event,c.filter.type,c.key)"
              />
              <div v-if="c.filter.type == 'select'">
                <!-- v-if="c.filter.type == 'select'"-->
                <Dropdown
                    v-if="getField(c) == 'id_district_key'"
                    :key="countDropdown"
                    v-model="filters[getField(c)]"
                    :options="list_dictrict_filter"
                    :optionLabel="c.filter.optionLabel"
                    :optionValue="c.filter.optionKey"
                    :placeholder="getFilterPlaceHolder(c)"
                    class="p-column-filter"
                    :showClear="true"
                    appendTo="body"
                    :filter="true"
                    @change="onFilter($event,c.filter.type,c.key)"
                >
                  <template #option="slotProps">
                    <div class="p-clearfix">
                    <span
                        :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                    >{{ slotProps.option[c.filter.optionLabel] }}</span
                    >
                    </div>
                  </template>
                </Dropdown>
                <Dropdown
                    v-else-if="getField(c) == 'id_ward_key'"
                    :key="countDropdown"
                    v-model="filters[getField(c)]"
                    :options="list_ward_filter"
                    :optionLabel="c.filter.optionLabel"
                    :optionValue="c.filter.optionKey"
                    :placeholder="getFilterPlaceHolder(c)"
                    class="p-column-filter"
                    :showClear="true"
                    appendTo="body"
                    :filter="true"
                    @change="onFilter($event,c.filter.type,c.key)"
                >
                  <template #option="slotProps">
                    <div class="p-clearfix">
                    <span
                        :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                    >{{ slotProps.option[c.filter.optionLabel] }}</span
                    >
                    </div>
                  </template>
                </Dropdown>
                <Dropdown
                    v-else
                    :key="countDropdown"
                    v-model="filters[getField(c)]"
                    :options="getFilterOptions(c.key)"
                    :optionLabel="c.filter.optionLabel"
                    :optionValue="c.filter.optionKey"
                    :placeholder="getFilterPlaceHolder(c)"
                    class="p-column-filter"
                    :showClear="true"
                    appendTo="body"
                    :filter="true"
                    @change="onFilter($event,c.filter.type,c.key)"
                >
                  <template #option="slotProps">
                    <div class="p-clearfix">
                    <span
                        :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                    >{{ slotProps.option[c.filter.optionLabel] }}</span
                    >
                    </div>
                  </template>
                </Dropdown>
              </div>

              <!--<Calendar
                v-if="c.filter.type == 'DateRange'"
                :showOnFocus="false"
                :monthNavigator="true"
                :yearNavigator="true"
                yearRange="2000:2030"
                dateFormat="yy-mm-dd"
                id="date_from"
                v-model="filters[getField(c)]"
                class="p-column-filter"
                :showIcon="true"
                selectionMode="range"
                appendTo="body"
                :showClear="true"
                @date-select="select_date($event,getField(c))"
                :manualInput="false"
                />-->
              <!--<Calendar
                  v-if="c.filter != undefined && c.filter.type == 'DateRange' && (c.filter.visible === undefined || (c.filter.visible !== undefined && c.filter.visible))"
                  :id="c.key + 'from'"
                  :dateFormat="$commonFuction.formatDateCalenda('Date')"
                  :value="getValueDateRange(c, 'from')"
                  class="p-column-filter date-custom"
                  :showIcon="true"
                  :showButtonBar="true"
                  :manualInput="false"
                  appendTo="body"
                  :placeholder="'Từ ngày'"
                  @date-select="selectChangeDate($event, c, 'from')"
                  @clear-click="clearChangeDate( c, 'from')"

              />
              <Calendar
                  v-if="c.filter != undefined && c.filter.type == 'DateRange' && (c.filter.visible === undefined || (c.filter.visible !== undefined && c.filter.visible))"
                  :id="c.key + 'to'"
                  :dateFormat="$commonFuction.formatDateCalenda('Date')"
                  :value="getValueDateRange(c, 'to')"
                  class="p-column-filter date-custom"
                  :showIcon="true"
                  :showButtonBar="true"
                  :manualInput="false"
                  appendTo="body"
                  :placeholder="'Đến ngày'"
                  @date-select="selectChangeDate($event, c, 'to')"
                  @clear-click="clearChangeDate(c, 'to')"

              />-->
              <Calendar
                  v-if="c.filter.type == 'DateRange'"
                  :showOnFocus="false"
                  :monthNavigator="true"
                  :yearNavigator="true"
                  yearRange="1900:2500"
                  dateFormat="dd-mm-yy"
                  id="date_from"
                  v-model="filters[getField(c)]"
                  class="p-column-filter"
                  :showIcon="true"
                  selectionMode="range"
                  appendTo="body"
                  :showClear="true"
                  :showButtonBar="true"
                  @clear-click="onFilter($event,c.filter.type,c.key)"
                  @date-select="onFilter($event,c.filter.type,c.key)"
                  :manualInput="true"

              /><!--:style="getHeaderStyle(c)"-->
            </template>
          </Column>
          <Column
              v-if="getRowActions()"
              headerStyle="width: 8em; text-align: center"
              bodyStyle="width: 8em; text-align: center"
          >
            <template #body="slotProps">
              <span class="p-column-title">Actions</span>
              {{ slotProps.data.color }}
              <Button
                  v-for="(a, k) in getRowActions().rows(slotProps.data)"
                  :key="k"
                  type="button"
                  :icon="getIcon(a.icon)"
                  :class="getClass(a.name)"
                  :disabled="getDisabled(a.disabled)"
                  style="margin-right: 0.5em;"
                  v-on:click="actionsClicked(k, a, slotProps)"
              ></Button>
            </template>
            <template #header="slotProps">
              <Button
                  v-if="getRowActions().header"
                  type="button"
                  :icon="getIcon(getRowActions().header.icon)"
                  :class="getClass(getRowActions().header.name)"
                  v-on:click="actionsClicked(getRowActions().header.name, getRowActions().header, slotProps)"
              ></Button>
            </template>
            <template #filter>
<!--              <Button style="margin: 0px 2px" icon="pi pi-search" class="p-button-info" @click="onFilterData" />
              <Button style="margin: 0px 2px" icon="pi pi-times"  class="p-button-danger" @click="clearFilterData" />-->
              <!-- <Button label="Tìm kiếm" @click="onFilterData" />-->
            </template>
          </Column>
          <template #empty>
            {{ $t('datatable.empty') }}
          </template>
          <template #loading>
            {{ $t('datatable.loading') }}
          </template>
          <template #footer>
            Tổng số văn bản: {{ totalDataChange }}
            <span style="margin-left: 30px"></span>
            Tổng tiền: {{ formatCurrency(total_price_all) }}
          </template>
        </DataTable>

        <!-- <div class="card">Tổng số văn bản: {{ totalDoc }}</div> -->
        <div style="display: none;">
          <img id='barcode' />
        </div>

        <Dialog
            header="Xóa"
            :visible.sync="showDeleteDialog"
            :contentStyle="{overflow: 'visible'}"
            :modal="true"
        >
          Bạn có chắc muốn xóa <strong>{{this.deleteName}}</strong>
          <template
              #footer
          >
            <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
            <Button
                label="Hủy"
                @click="showDeleteDialog = false"
                icon="pi pi-times"
                class="p-button-warning"
            />
          </template>
        </Dialog>
        <Popup
            v-if="editDialogKey > 0"
            :key="editDialogKey"
            :show="displayDialog"

        ></Popup>
<!--
 :mode="dialogMode"
            :model="modelEdit"
            :modelName="modelName"
            :screen="'service_supplies'"
            @refresh="refreshData"
 -->
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import gql from "graphql-tag";
import moment from "moment-timezone";
import XLSX from "xlsx"
import graphql from '../common/graphql'
import jsPDF from "jspdf"
import JsBarcode from 'jsbarcode'
import 'jspdf-autotable'
import store from '@/store'
import Popup from './popup'

export default {
  components: {
    Popup
  },
  data() {
    return {
    is_show_progress: false,
      progress: 0,
      total_price_all:0,
      text_total_page:'Tổng số văn bản: 0       Tổng tiền:0 ',
      filterOptions: {},
      listData: [],
      options: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      totalDoc: 0,
      //
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: 10, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [5, 10, 20, 50, 100],
      selectedRows: null,
      // IMPORT
      hasErrors: 0,
      lstCurrDocument: {},
      onlyName: [],
      onlyDate: [],
      onlyAddress: [],
      lstCurrState: {},
      lstCurrDistrict: {},
      lstCurrWard: {},
      lstCurrOfficeTPL: {},
      lstCurrOfficeAgency: {},
      lstCurrArea: {},
      state_id: null,
      district_id: null,
      tpl_id: null,
      agency_id: null,
      area_id: null,
      is_fee_budget: 0,
      is_urgent : false,
      type_document: 1,
      code_system: null,
      tdv_id: null,
      // EXPORT
      refreshExport: 0,
      totalDataChange: 0,
      firstRecordIndex:0,
      totalRecordsL:0,
      listDataService:null,
      filtersCustom: [],
      lazyParams: {},
      componentKeyW: 0,
      listColumns: [],
      where_filter: {},
      list_dictrict_filter:[],
      list_ward_filter:[],
      list_holiday:[],
      role_key:null,
      exportConfigs: {
        sheetInfo: 'CÔNG TY CỔ PHẦN ENGMA',
        header: 'DANH SÁCH VĂN BẢN',
        // subTitle: (data) => {
        //   let subTitle = '';
        //   console.log(data);
        //   if (this.filters && this.filters['date']) {
        //     dateFrom = moment(this.filters['date'][0]).format('DD/MM/YYYY');
        //     dateEnd = moment(this.filters['date'][1]).format('DD/MM/YYYY');
        //   }

        //   subTitle = `Từ ngày ${dateFrom} đến ngày ${dateEnd}`;
        //   return subTitle;
        // },
        colHeaderStyle: 'background-color:#bfbfbf; font-weight: bold; border: solid 1px #fffff',
        fields: {
          'STT  ': 'stt',
          'NGƯỜI TẠO': {
            field: 'create_by',
            callback: (value) => {
              if (value){
                return (value.fullname) ? value.fullname:''
              }
              return '';
            },
          },
          'ĐÃ IN MÃ CODE': {
            callback: (row) => {
              if (row.scan_barcode){
                return 1;
              }
              return ''
            }
          },
          'MÃ VB HỆ THỐNG': 'code_system',
          'MÃ VB CỦA TÒA': 'code_court',
          'SỐ QUYẾT ĐỊNH': 'number_decision',
          'NỘI DUNG VB': 'content_document',
          'NGÀY BAN HÀNH': {
            field: 'date_issued',
            callback: (value) => {
              if (value)
                return moment
                    .utc(value)
                    .clone()
                    .tz('Asia/Ho_Chi_Minh')
                    .format('DD/MM/YYYY');
            },
          },
          'NGÀY MỜI': {
            field: 'date_invite',
            callback: (value) => {
              if (value)
                return moment
                    .utc(value)
                    .clone()
                    .tz('Asia/Ho_Chi_Minh')
                    .format('DD/MM/YYYY');
            },
          },
          'TÊN ĐƯƠNG SỰ': 'name_litigant',
          'ĐỊA CHỈ': 'address',
          'PHƯỜNG/ XÃ': {
            callback: (row) => {
              return (!this.$commonFuction.isEmpty(row.ward)) ? row.ward.name:'';
            }
          },
          'QUẬN/ HUYỆN': {
            callback: (row) => {
              return (!this.$commonFuction.isEmpty(row.district)) ? row.district.name:'';
            }
          },
          'TP/ TỈNH': {
            callback: (row) => {
              return row.state.name
            }
          },
          'SỐ ĐIỆN THOẠI': 'phone_litigant',
          'NGƯỜI KÝ': 'signer',
          'MÃ CƠ QUAN': 'code_agency',
          'NGÀY NHẬN VB TỪ TÒA': {
            field: 'date_receipt_court',
            callback: (value) => {
              if (value)
                return moment
                    .utc(value)
                    .clone()
                    .tz('Asia/Ho_Chi_Minh')
                    .format('DD/MM/YYYY');
            },
          },
          'NGÀY TRẢ TÒA': {
            field: 'date_return_court',
            callback: (value) => {
              if (value)
                return moment
                    .utc(value)
                    .clone()
                    .tz('Asia/Ho_Chi_Minh')
                    .format('DD/MM/YYYY');
            },
          },
          'LOẠI': 'type_document',
          'GẤP': {
            callback: (row) => {
              if (row.is_urgent) {
                return 'Gấp';
              } else {
                return '';
              }
            }
          },
          'HỌ & TÊN TĐV': {
            callback: (row) => {
              if (row.tdv) {
                return (row.tdv.fullname) ? row.tdv.fullname:'';
              }
              return '';
            }
          },
          'NGÀY TĐV NHẬN VB': {
            field: 'date_tdv_receipt',
            callback: (value) => {
              if (value)
                return moment
                    .utc(value)
                    .clone()
                    .tz('Asia/Ho_Chi_Minh')
                    .format('DD/MM/YYYY');
            },
          },
          'NGÀY TĐV TRẢ VB': {
            field: 'date_tdv_return',
            callback: (value) => {
              if (value)
                return moment
                    .utc(value)
                    .clone()
                    .tz('Asia/Ho_Chi_Minh')
                    .format('DD/MM/YYYY');
            },
          },
          'NGÀY VB HOÀN THÀNH': {
            field: 'date_complete',
            callback: (value) => {
              if (value)
                return moment
                    .utc(value)
                    .clone()
                    .tz('Asia/Ho_Chi_Minh')
                    .format('DD/MM/YYYY');
            },
          },
          'MÃ VPLK': {
            callback: (row) => {
              if (row.office_vplk) {
                return (row.office_vplk.code) ? row.office_vplk.code:'';
              }
              return '';
            }
          },
          'MÃ KHU VỰC': 'code_area',
          'TRẠNG THÁI VB': {
            callback: (row) => {
              if (row.status_document) {
                return (row.status_document.name) ? row.status_document.name:'';
              }
              return '';
            }
          },
          'HÌNH THỨC TĐ': {
            callback: (row) => {
              if (row.status_tongdat) {
                return (row.status_tongdat.name) ? row.status_tongdat.name:'';
              }
              return '';
            }
          },

        },
        fetch: async () => {
          let data = [];
          let arrIDs = []
          if (this.selectedRows && this.selectedRows.length > 0) {
            for (let i = 0; i < this.selectedRows.length; i++) {
              arrIDs.push(this.selectedRows[i].id)
            }
          }
          if (arrIDs.length > 0) {
            //DataServices.getList(this.modelName);
            await this.$apollo.query({
              //query: gql(graphql.GET_DOCUMENT),
              query: DataServices.getList('list_document'),
              variables: {
                where_key: {
                  id: {'_in': arrIDs}
                }
              },
              fetchPolicy: "no-cache"
            }).then(async (resData) => {
              // console.log("=============fetch data", resData)
              let lstdata = resData.data.document;
              for (let i = 0; i < lstdata.length; i++) {
                lstdata[i].stt = i + 1;
                data.push(lstdata[i]);
              }
            }).catch((error) => {
              console.log(error);
            });
            // console.log("Fecth return", data)
            if (data.length > 0) {
              this.selectedRows = null;
              this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xuất file excel thành công', life: 3000 })
              return data;
            } else {
              this.selectedRows = null;
              this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Xuất file excel không thành công', life: 3000 })
              return data;
            }
          } else {
            this.selectedRows = null;
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng chọn ít nhất 1 văn bản', life: 3000 })
            return data;
          }

        },
        name: 'Xuất Excel.xls',
      },
      dateType: 0
    }
  },
  beforeCreate() {
    if (store.getters.group_permission && store.getters.group_permission.list_document.list == false && store.getters.role != "admin") {
      this.$router.push({name: '404'})
    }
  },
  async created() {
    this.role_key = store.getters.role
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel('list_document')
    this.title = this.dataModel.label

    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
     if (!this.$commonFuction.isEmpty(this.$route.query)){
       if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
         this.page_transaction = this.$route.query.page_transaction;
         this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
         this.firstRecordIndex = this.lazyParams.first;
         // console.log("this.lazyParams:22222222",this.lazyParams);
         /*if (this.lazyParams){
           this.filters = (this.lazyParams.filters) ? this.lazyParams.filters : {};
         }*/
       }
     }
    //this.filtersCustom = this.map_custom_filter;
    this.filtersCustom = [];
    this.onLazyEvent(true);

    /*this.$store.commit('setLoading', true);
    this.loading = false;
    this.countDropdown++;*/
    //this.$apollo.queries.listData.refresh();
    this.callbackOptions();
    //lấy ngày lễ
    var list_holiday =await this.$CoreService.getListHoliday();
    this.list_holiday = list_holiday;
  },
  mouted() {
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    callbackDataSelect(c,data){
      var text = "";
      switch(c.key) {
        case 'id_ward_key':
          text = (!this.$commonFuction.isEmpty(data.ward)) ? data.ward.name:'';
          break;
        case 'id_district_key':
          text = (!this.$commonFuction.isEmpty(data.district)) ? data.district.name:'';
          break;
        case 'code_agency_tpl':
          text = (!this.$commonFuction.isEmpty(data.code_agency)) ? data.code_agency:'';
          break;
        default:
          // code block
      }
      return text;
    },
    async export_excel_document(type) {
      //this.$store.commit('setLoadingCustom', true);
      var that = this;
      try {
        var dataPost = {
          role:this.$store.getters.role,
          type:1,
          timezone_client :moment.tz.guess()
        };
        if (type == 2){
          dataPost.type = 2;
          let arrIDs = []
          if (this.selectedRows && this.selectedRows.length > 0) {
            for (let i = 0; i < this.selectedRows.length; i++) {
              arrIDs.push(this.selectedRows[i].id)
            }
          }
          dataPost.list_id = arrIDs;
          if (arrIDs.length < 1){
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng chọn ít nhất 1 văn bản', life: 3000 })
            return false;
          }
        }else {
          dataPost.where_all = this.where_filter;
        }
        const headers = {
          "Authorization": "Bearer "+store.getters.token,
        };
         this.is_show_progress = true;
         this.progress = 1;
        var dataResponse = await that.$CoreService.callApiPost('/_api/export_excel/export_list_document',dataPost, headers)
        var id_history_export = dataResponse.data.data.id_history_export;
       
        var start = 0;
        var refreshIntervalId = setInterval(
            function(){
              if (start == 0){
                start = 1;
                var dataPostFile = {id_history_export:id_history_export}
                that.$CoreService.callApiPost('/_api/export_excel/read_file_export',dataPostFile, {}).then(async (resData) => {
                  console.log("=============fetch data", resData)
                  if(parseInt(resData.data.data.percent) >0){
                    that.progress = parseInt(resData.data.data.percent);
                  }
                  if (parseFloat(resData.data.data.process_status) == 1){
                    console.log("dataResponseprocess_status 1")
                    start = 0;
                  }else if (parseFloat(resData.data.data.process_status) == 2){
                    that.progress = 100;
                    setTimeout(() => {
                      that.is_show_progress = false;
                      var link = document.createElement('a');
                      link.href = resData.data.data.url;
                      link.download = that.$commonFuction.basename(resData.data.data.url);
                      link.dispatchEvent(new MouseEvent('click'));
                      console.log("dataResponse.data.data:",resData.data.data)
                    // that.$store.commit('setLoadingCustom', false);
                      console.log("that.progress",that.progress)
                      
                    }, 2000);
                    clearInterval(refreshIntervalId);
                    
                  }else {
                    console.log("dataResponseprocess_status khong ton tai")
                    //Xuất file thất bại
                  //  that.$store.commit('setLoadingCustom', false);
                    that.is_show_progress = false;
                    alert("Xuất file thất bại");
                    clearInterval(refreshIntervalId);
                  }

                }).catch((error) => {
                  clearInterval(refreshIntervalId);
                  //that.$store.commit('setLoadingCustom', false);
                  alert("Xuất file thất bại");
                   that.is_show_progress = false;
                  if (error);
                });
              }
            }, 5000);
      } catch (err) {
        console.log("err:",err);
        this.showConfirmDialog = true;
        this.creenConfirmDialog = 'export_err';
        alert("Xuất file thất bại");
        this.is_show_progress = false;
      }
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel('list_document');
      // console.log(this.dataModel)
      this.title = this.dataModel.label;
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    // đổi màu cho row
    rowClass(data) {
      if (data.deadline_color === 1) return 'row-warning'
      else if (data.deadline_color === 2) return 'row-error'
      else return null;
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields()
      var attributes = [];
      for (let index = 0; index < fields.length; index++) {
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          var optionsData = [];
          attributes.push(element.models.key.key);
          attributes.push(element.models.display_key);
          var where_status = {}
          if (element.key == 'code_agency_tpl'){
            where_status.deleted = {_eq: false};
            attributes.push('code');
          }
          var tableName = element.models.tableName
          var {data} = await this.$apollo.query({
            query: DataServices.getList(tableName, {"fields" : attributes.join(',')}),
            variables: {where_key : where_status}
          })
          if (data) {
            var result = data[Object.keys(data)];
            if (result) {
              for (let index = 0; index < result.length; index++) {
                const ele = result[index];
                if (element.key == 'code_agency_tpl') {
                  //console.log("eleeleeleele:",ele)
                  optionsData.push({value: ele['code'], label: ele['code']+' - '+ele['name']})
                }else {
                  optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
                }
              }
            }
          }
          this.options[element.key] = optionsData;
        }
        this.componentKey++;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // actions.header = { name: 'add', icon: 'plus', path: `import-document/add`};
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        // buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-manager/view/`};
        var hasEditAfterSalaryPermission = store.getters.group_permission && store.getters.group_permission.edit_document_after_salary && store.getters.group_permission.edit_document_after_salary.edit == true;
        var isSalaryLockedForEdit = (store.getters.role == 'dpv' || store.getters.role == 'court') && !hasEditAfterSalaryPermission && rowData.status_document && rowData.status_document.ordinal >= 9;
        if (!isSalaryLockedForEdit && ((store.getters.group_permission && store.getters.group_permission.list_document.edit == true) || store.getters.role == "admin")) {
          buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `list-document/edit/`}
        }
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        if ((store.getters.group_permission && store.getters.group_permission.list_document.delete == true) || store.getters.role == "admin") {
          buttons.delete = { name: 'delete', icon: 'trash', key: 'id'}
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async actionsClicked(key, action, data) {
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    deleteData() {
      var that =this;
      this.showDeleteDialog = false
      /*var query = DataServices.deleteData(this.modelName)
      var variables = {
        where_key: {
          id: {'_eq': this.deleteId}
        }
      }
      this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(res => {
        if (res.data.delete_document.affected_rows > 0) {
          this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        } else this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Xóa dữ liệu thất bại', life: 3000 })
        this.$apollo.queries.listData.refresh()
      }).catch((error) => {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Xóa dữ liệu gặp vấn đề', life: 3000 })
        console.error('ERROR: ', error)
      });*/
      var pageTransaction = (new Date()).getTime();
      var query = DataServices.updateData(this.modelName)
      this.$store.commit('setLoadingCustom', true);
      var variables = {
        where_key: {
          id: {'_eq': this.deleteId}
        },
        'data_update': {
          'deleted': true
        },
      }
      this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(() => {
        //if (res.data.delete_document.affected_rows > 0) {
        localStorage.setItem(pageTransaction.toString(), JSON.stringify(that.lazyParams));
        /*var router_back = {path: '/admin/list-document'};
        if (!that.$commonFuction.isEmpty(router_back)){
          //console.log("that.page_transaction:",that.lazyParams);
          router_back.query = { page_transaction: pageTransaction.toString(),key_auto: ((new Date()).getTime()).toString() };
        }*/
        //that.$router.push(router_back);
        window.location.href = '/admin/list-document?page_transaction='+pageTransaction.toString();
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        //} else this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Xóa dữ liệu thất bại', life: 3000 })
       // this.$apollo.queries.listData.refresh()
      }).catch((error) => {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Xóa dữ liệu gặp vấn đề', life: 3000 })
        console.error('ERROR: ', error)
        this.$store.commit('setLoadingCustom', false);
      });
    },
    async onExportExcelBarcodeService(type) {
      var that = this;
      let arrIDs = [];
      let arrNotAssign = [];
      var arrIdExport = [];
       this.is_show_progress = true;
       this.progress = 1;
      //if (this.selectedRows && this.selectedRows.length > 0) {
    //  this.$store.commit("setLoadingCustom", true);
      /*var dataJson = [];
      for (let index = 0; index < this.selectedRows.length; index++) {
        var item = this.selectedRows[index];
        if (item['code_system'] != undefined && item['code_system'] != '' &&
            item['name_litigant'] != undefined && item['name_litigant'] != '' ) {
          dataJson.push({
            'Mã vạch': item['code_system'],
            'Tên đương sự': item['name_litigant'].slice(0,18)
          });
          arrIdExport.push(item.id)
        }
        for (let j = 0; j < this.listData.length; j++) {
          if (this.listData[j].id === item.id && this.listData[j].tdv !== null) {
            arrIDs.push(item.id)
            break;
          } else if (this.listData[j].id === item.id && this.listData[j].tdv === null) {
            arrNotAssign.push(item.code_system)
          }
        }
      }*/
      var dataPost = {
        type:1
      };
      if (type == 1){
        dataPost.where_all = this.where_filter;
        var variables = {
          where_key: this.where_filter,
        }
        var data_list = await this.$CoreService.getListVar('list_document',variables);
        var list = [];
        if (!this.$commonFuction.isEmpty(data_list.document)){
          list = data_list.document;
        }
        for (var i=0;i<list.length;i++){
          if (list[i].tdv !== null) {
            if (list[i].scan_barcode == false) {
              arrIDs.push(list[i].id)
            }
          } else if ( list[i].tdv === null) {
            arrNotAssign.push(list[i].code_system)
          }
        }
      }else {
        var dataJson = [];
        for (let index = 0; index < this.selectedRows.length; index++) {
          var item = this.selectedRows[index];
          if (item['code_system'] != undefined && item['code_system'] != '' &&
              item['name_litigant'] != undefined && item['name_litigant'] != '' ) {
            dataJson.push({
              'Mã vạch': item['code_system'],
              'Tên đương sự': item['name_litigant'].slice(0,18)
            });
            arrIdExport.push(item.id)
          }
          if (item.tdv !== null) {
            if (item.scan_barcode == false) {
              arrIDs.push(item.id)
            }
          } else if ( item.tdv === null) {
            arrNotAssign.push(item.code_system)
          }
          /*for (let j = 0; j < this.listData.length; j++) {
            if (this.listData[j].id === item.id && this.listData[j].tdv !== null) {
              arrIDs.push(item.id)
              break;
            } else if (this.listData[j].id === item.id && this.listData[j].tdv === null) {
              arrNotAssign.push(item.code_system)
            }
          }*/
        }
        dataPost.type = 2;
        dataPost.list_id = arrIdExport;
        /*if (dataJson !== null) {
          var dataSheet = XLSX.utils.json_to_sheet(dataJson)
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataSheet)
          XLSX.writeFile(wb, 'barcode.xlsx')
          this.$store.commit('setLoading', true);
        }*/
      }

      try {
        const headers = {
          "Authorization": "Bearer "+store.getters.token,
        };
       
        var dataResponse = await that.$CoreService.callApiPost('/_api/export_excel/export_barcode_document',dataPost, headers)
        var id_history_export = dataResponse.data.data.id_history_export;
        var start = 0;
        var refreshIntervalId = setInterval(
            function(){
              if (start == 0){
                start = 1;
                var dataPostFile = {id_history_export:id_history_export}
                that.$CoreService.callApiPost('/_api/export_excel/read_file_export',dataPostFile, {}).then(async (resData) => {
                  //console.log("=============fetch data", resData)
                  if(parseInt(resData.data.data.percent) >0){
                    that.progress = parseInt(resData.data.data.percent);
                  }
                  if (resData.data.data.process_status == 1){
                    start = 0;
                  }else if (resData.data.data.process_status == 2){
                    
                    setTimeout(() => {
                      that.is_show_progress = false;
                       var link = document.createElement('a');
                      link.href = resData.data.data.url;
                      link.download = that.$commonFuction.basename(resData.data.data.url);
                      link.dispatchEvent(new MouseEvent('click'));
                      //console.log("dataResponse.data.data:",resData.data.data)
                     // that.$store.commit('setLoadingCustom', false);
                      
                    }, 2000);
                    clearInterval(refreshIntervalId);
                   
                  }else {
                    //Xuất file thất bại
                    that.is_show_progress = false;
                    alert("Xuất file thất bại");
                  //  that.$store.commit('setLoadingCustom', false);
                    clearInterval(refreshIntervalId);
                  }

                }).catch((error) => {
                  that.is_show_progress = false;
                    alert("Xuất file thất bại");
                  clearInterval(refreshIntervalId);
                //  that.$store.commit('setLoadingCustom', false);
                  if (error);
                });
              }
            }, 5000);
      } catch (err) {
        console.log("err:",err);
        that.is_show_progress = false;
        alert("Xuất file thất bại");
        this.showConfirmDialog = true;
        this.creenConfirmDialog = 'export_err';
      }

      if (arrIDs.length > 0) {
        var where_update = {};
        where_update.id = {'_in': arrIDs};
        where_update.scan_barcode = {'_eq': false};//gioi han dong update
        let variables = {
          'data_update': {
            // is_confirmed: true,
            // date_tdv_receipt: new Date().toISOString(),
            // status_vb_id: 2,
            scan_barcode: true
          },
          'where_key': where_update
        };
        await this.$apollo.mutate({
          mutation: DataServices.updateData('document'),
          variables: variables
        })/*.then(async (res) => {
            if (res.data[Object.keys(res.data)].affected_rows) {
              // this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật dữ liệu thành công', life: 3000 })
              // this.$store.commit('setLoading', true);
              this.$apollo.queries.listData.refresh()
            }
          })*/.then(async () => {
          //location.reload();
        }).catch((error) => {
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Cập nhật dữ liệu gặp vấn đề', life: 10000 })
          console.error('ERROR: ', error)
        });
      }
      if (arrNotAssign.length > 0) {
        this.$toast.add({ severity: 'error', summary: 'Cảnh báo', detail: 'Một số văn bản không có TĐV: ' + arrNotAssign.join(', '), life: 10000 })
      }
      // }
    },
    async onExportExcelBarcode() {
      let arrIDs = [];
      let arrNotAssign = [];
      if (this.selectedRows && this.selectedRows.length > 0) {
        this.$store.commit("setLoading", true);
        var dataJson = [];
        for (let index = 0; index < this.selectedRows.length; index++) {
          var item = this.selectedRows[index];
          if (item['code_system'] != undefined && item['code_system'] != '' &&
              item['name_litigant'] != undefined && item['name_litigant'] != '' ) {
            dataJson.push({
              'Mã vạch': item['code_system'],
              'Tên đương sự': item['name_litigant'].slice(0,18)
            });
          }
          for (let j = 0; j < this.listData.length; j++) {
            if (this.listData[j].id === item.id && this.listData[j].tdv !== null) {
              arrIDs.push(item.id)
              break;
            } else if (this.listData[j].id === item.id && this.listData[j].tdv === null) {
              arrNotAssign.push(item.code_system)
            }
          }
        }
        if (dataJson !== null) {
          var dataSheet = XLSX.utils.json_to_sheet(dataJson)
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataSheet)
          XLSX.writeFile(wb, 'barcode.xlsx')
          this.$store.commit('setLoading', true);
        }
        if (arrIDs.length > 0) {
          let variables = {
            'data_update': {
              // is_confirmed: true,
              // date_tdv_receipt: new Date().toISOString(),
              // status_vb_id: 2,
              scan_barcode: true
            },
            'where_key': {
              id: {'_in': arrIDs}
            }
          };
          await this.$apollo.mutate({
            mutation: DataServices.updateData('document'),
            variables: variables
          }).then(async (res) => {
            if (res.data[Object.keys(res.data)].affected_rows) {
              // this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật dữ liệu thành công', life: 3000 })
              // this.$store.commit('setLoading', true);
              this.$apollo.queries.listData.refresh()
            }
          }).then(async () => {
            location.reload();
          }).catch((error) => {
            this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Cập nhật dữ liệu gặp vấn đề', life: 10000 })
            console.error('ERROR: ', error)
          });
        }
        if (arrNotAssign.length > 0) {
          this.$toast.add({ severity: 'error', summary: 'Cảnh báo', detail: 'Một số văn bản không có TĐV: ' + arrNotAssign.join(', '), life: 10000 })
        }
      }
    },
    async onExportBarcode() {
      // console.log('Xuat barcode: ', this.selectedRows)
      let arrIDs = [];
      let arrNotAssign = [];
      let dataUpdate = {
        is_confirmed: true,
        date_tdv_receipt: new Date().toISOString(),
        status_vb_id: 2,
        scan_barcode: true
      }
      if (this.selectedRows && this.selectedRows.length > 0) {
        for (let i = 0; i < this.selectedRows.length; i++) {
          for (let j = 0; j < this.listData.length; j++) {
            if (this.listData[j].id === this.selectedRows[i].id && this.listData[j].tdv !== null) {
              arrIDs.push(this.selectedRows[i].id)
            } else if (this.listData[j].id === this.selectedRows[i].id && this.listData[j].tdv === null) {
              arrNotAssign.push(this.selectedRows[i].code_system)
            }
          }
        }
        //
        if (arrIDs.length > 0) {
          let variables = {
            'data_update': dataUpdate,
            'where_key': {
              id: {'_in': arrIDs}
            }
          };
          await this.$apollo.mutate({
            mutation: DataServices.updateData('document'),
            variables: variables
          }).then(async (res) => {
            if (res.data[Object.keys(res.data)].affected_rows) {
              // this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật dữ liệu thành công', life: 3000 })
              this.$store.commit('setLoading', true);
              this.$apollo.queries.listData.refresh()
            }
          }).catch((error) => {
            this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Cập nhật dữ liệu gặp vấn đề', life: 3000 })
            console.error('ERROR: ', error)
          });
        }
        if (arrNotAssign.length > 0) {
          this.$toast.add({ severity: 'error', summary: 'Cảnh báo', detail: 'Một số văn bản không có TĐV: ' + arrNotAssign.join(', '), life: 4000 })
        }
        //
        var doc = new jsPDF('p', 'mm');
        var x = 10;
        var y = 5;
        var width = 55;
        var height = 25;
        var count = 0;
        // var pageWidth = 210;
        var pageHeight = 295;
        for (let i = 0; i < this.selectedRows.length; i++) {
          let code = this.selectedRows[i].code_system;
          // console.log(code);
          // console.log(count)
          // console.log(x)
          // console.log(y)
          JsBarcode("#barcode", code, {format: "CODE128"});
          const img = document.querySelector('img#barcode');
          doc.addImage(img.src, 'PNG', x, y, width, height);
          count++;
          if (count == 3) {
            // SET LẠI BAN ĐẦU KHI NHẢY QUA HÀNG TIẾP THEO
            count = 0;
            x = 10;
            y += (height + 4);
          } else {
            // IN CÙNG HÀNG
            x += (12 + width);
          }

          if (y + height >= pageHeight) {
            doc.addPage(); // break-page
            x = 10;
            y = 5;
          }
        }
        doc.save('barcode.pdf');
        this.selectedRows = null;
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xuất mã barcode thành công', life: 3000 })
      }
    },
    async assignTDV(wardID) {
      // console.log(wardID)
      var {data} = await this.$apollo.query({
        query: gql(graphql.GET_USERS_WARD),
        variables: {
          where: {
            ward_id: {'_eq': wardID},
            user: {
              users_account: {
                role: {'_eq': 'tdv'}
              }
            }
          },
          distinct_on: "user_id",
          limit: 1
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      this.tdv_id = null;
      if (model.length > 0) {
        this.tdv_id = model[0].user_id;
      }
    },
    // GỘP HÀM
    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm:ss DD/MM/yyyy");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      }
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn ${this.getLabel(col).toLowerCase()}`;
      } else if (col.filter.type == "input") {
        return `Nhập ${this.getLabel(col).toLowerCase()}`;
      } else {
        return `Lọc`;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
    customFilter( itemLabel, filterValue) {
      return this.$CoreService.customFilterCore(itemLabel, filterValue , this.dateType);
    },
    onFilterDate(payload) {
      if (payload.col.filter.type == 'Date') this.dateType = 1;
      else if (payload.col.filter.type == 'DateRange') this.dateType = 2;
      else this.dateType = 0;
      if (payload.type != undefined && payload.type != '' && (payload.type == 'from' || payload.type == 'to')) {
        if (this.filters[payload.col.key] == undefined ) this.filters[payload.col.key] = {};
        if (payload.data != undefined) {
          this.filters[payload.col.key][payload.type] = payload.data;
          if (this.filters[payload.col.key] != null && this.filters[payload.col.key]['from'] != null && this.filters[payload.col.key]['to'] != null) {
            var date1 = new Date(moment(this.filters[payload.col.key]['from']).format('YYYY-MM-DD'));
            var date2 = new Date(moment(this.filters[payload.col.key]['to']).format('YYYY-MM-DD'));
            if (Number(date1) > Number(date2)) {
              var dateTemp = this.filters[payload.col.key]['from'];
              this.filters[payload.col.key]['from'] = this.filters[payload.col.key]['to'];
              this.filters[payload.col.key]['to'] = dateTemp;
            }
          }
        }
        else delete this.filters[payload.col.key][payload.type];
      } else {
        this.filters[payload.col.key] = payload.data;
      }
      //croll lại vị trí filter
      this.$commonFuction.scroll_back_filter(payload.col.key+payload.type);
      this.componentKey = Math.random() * 320;
    },
    selectChangeDate(event, col, type = '') {
      var payload = {
        data: event,
        col: col,
        type: type,
        format: this.$commonFuction.formatDateCalenda('Date')
      }
      this.onFilterDate(payload);
    },
    clearChangeDate(col, type = '') {
      var date = this.filters[this.getField(col)];
      if (date != null) {
        if (type == '') delete this.filters[this.getField(col)];
        else if (type != '' && date[type] != undefined && date[type] != null) delete this.filters[this.getField(col)][type];
      }
      var payload = {
        col: col,
        type: type,
      }
      this.onFilterDate(payload);
    },
    getValueDateRange(col, target) {
      var date = this.filters[this.getField(col)];
      if (date != null) {
        if (target != '') {
          if (date[target] != undefined && date[target] != null) {
            return moment(date[target]).format(this.$commonFuction.formatDateCalenda('Date'));
          }
        } else return moment(date).format(this.$commonFuction.formatDateCalenda('Date'));
      }
      return null;
    },

    onPage(event) {
      //console.log("5555");
      this.lazyParams = event;
      this.onLazyEvent();
    },
    onLazyEvent(is_refesh_table=false) {
      this.lazyParams.filters = this.filtersCustom;
      this.loading = true;
      var that =this;
      var stt = this.lazyParams.first;
      this.dataList(this.lazyParams).then(async data => {
        var list_data = data.listData;
        var list_id_district = [];
        var list_id_ward = [];
        for (var t = 0; t < list_data.length; t++) {
          stt++;
          var item = list_data[t];
          list_data[t].sttKey = stt;
          if (!that.$commonFuction.isEmpty(item.district_id)){
            list_id_district.push(item.district_id);
          }
          if (!that.$commonFuction.isEmpty(item.ward_id)){
            list_id_ward.push(item.ward_id);
          }
          var date_receipt_court = (!this.$commonFuction.isEmpty(item.date_receipt_court)) ? item.date_receipt_court:null;
          var date_complete = (!this.$commonFuction.isEmpty(item.date_complete)) ? item.date_complete:null;
          var count_day_done = 0;
          if (!this.$commonFuction.isEmpty(date_receipt_court) && !this.$commonFuction.isEmpty(date_complete)){
            count_day_done = this.$CoreService.calcDenta(date_receipt_court,date_complete,that.list_holiday);
          }else {
            count_day_done = this.$CoreService.calcDenta(date_receipt_court,(new Date()).toISOString(),that.list_holiday);
          }
          list_data[t].total_day_doneKey = count_day_done;
          list_data[t].cost_document = (!this.$commonFuction.isEmpty(item.cost_document)) ? this.formatCurrency(item.cost_document):this.formatCurrency(0);

          //console.log("count_day_donecount_day_done:",count_day_done)
        }
        that.listColumns = DataServices.getModel('list_document');
        this.listColumns.processData(list_data);
        that.listColumns =this.listColumns.getDisplayFields();
        var list_display =[];
        console.log("this.$store.getters.role:",this.$store.getters.role)
        if (this.$store.getters.role == 'court'){
          list_display.push('code_vplk')
        }
        console.log("list_display:",list_display)
        if (list_display.length > 0) {
          this.listColumns = this.listColumns.filter(a => !list_display.includes(a.key))
        }
        var list_new_column = this.$commonFuction.convertJsonObject(this.listColumns)
        if (this.$store.getters.role == 'court'){
          for (var k=0;k<list_new_column.length;k++){
            var item_data= this.listColumns[k];
            if (item_data.name=='code_agency_tpl'){
              this.listColumns[k]["filter"] = {}
            }
          }

        }
        console.log("that.listColumnsthat.listColumns:",that.listColumns)
        console.log("this.firstRecordIndex:",this.firstRecordIndex)

        that.firstRecordIndex = this.lazyParams.first;
        that.paginationRows = this.lazyParams.rows;
        that.listDataService = list_data;
        that.totalDataChange = data.total;
        that.total_price_all = data.total_price;
        that.text_total_page = "Tổng số văn bản: "+that.totalDataChange+" \n       Tổng tiền:0 "
        if (is_refesh_table);
        //if (is_refesh_table == true){
        that.componentKey++;
        that.loading = false;
        //}
        //this.countRows();
        //that.totalRecordsL = data.total;
        //that.loading = false;
      });
    },
    async dataList(lazyParams) {
      //this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      //this.$store.commit('setLoading', true);
      //var vm = this;
      //var modelName = 'report_request_activation_product_serial';
      var offset = lazyParams.first;
      var limit = lazyParams.rows;
      var where = {
        /*status_document: {
          // code: {'_neq': "WAITING"},
          deleted: {'_eq': false}
        },*/
        deleted: {'_eq': false}
      }
      if (this.$store.getters.role == 'court'){
        if (store.getters.user){
          var list_code =await this.$CoreService.getListCodeAgencyCourt(store.getters.user);
          where["_and"] = {code_agency: {_in: list_code}}
        }
      }

      var filters = lazyParams.filters;
      //var dataFilterStatus = [];
      if (filters){
        for (const [key, value] of Object.entries(filters)) {
          if (!this.$commonFuction.isEmpty(value.value)){
            console.log("value.type_inputvalue.type_input:",value.type_input)
            switch(value.type_input) {
              case 'input':
                switch(key) {
                  case 'created_name':
                    if (this.$commonFuction.isEmpty(where.create_by)){
                      where.create_by = {};
                    }
                    where.create_by.fullname = {_ilike: "%"+value.value+"%"};
                    break;
                  case 'barcode':
                    var scan_barcode = false;
                    if (value.value.toString() == '1'){
                      scan_barcode = true;
                    }
                    where.scan_barcode = {'_eq': scan_barcode};
                    break;
                  case 'custom_urgent':
                    var custom_urgent = false;
                    if (value.value.toString().toLowerCase() == 'gấp'){
                      custom_urgent = true;
                    }
                    where.is_urgent = {'_eq': custom_urgent};
                    break;
                  case 'display_tdv':
                    if (this.$commonFuction.isEmpty(where.tdv)){
                      where.tdv = {};
                    }
                    where.tdv.fullname = {_ilike: "%"+value.value+"%"};
                    break;
                  case 'code_vplk':
                    if (this.$commonFuction.isEmpty(where.office_vplk)){
                      where.office_vplk = {};
                    }
                    where.office_vplk.code = {_ilike: "%"+value.value+"%"};
                    break;
                  case 'cost_document':
                    /*if (this.$commonFuction.isEmpty(where.office_vplk)){
                      where.cost_document_format = {};
                    }
                    where.office_vplk.code = {_ilike: "%"+value.value+"%"};*/
                    where['cost_document_format'] = {_ilike: "%"+value.value+"%"};
                    break;
                  case 'total_day_done':
                    //Cột "Tổng ngày hoàn thành VB" lấy trực tiếp từ cột count_day_done đã có sẵn trong DB
                    where['count_day_done'] = {'_eq': parseInt(value.value)};
                    break;
                  default:
                    where[key] = {_ilike: "%"+value.value+"%"};
                }
                break;
              case 'DateRange':
                where[key] = {'_gte': value.value.from,'_lte': value.value.to}
                /*if (key=='activation_date'){
                  where['activation_date'] = {'_gte': value.value.from,'_lte': value.value.to}
                }else {
                  where[key] = {'_gte': value.value.from,'_lte': value.value.to}
                }*/
                //console.log("5555555")
                console.log("value.value:",value.value)
                break;
              case 'select':
                switch(key) {
                  case 'id_district_key':
                    where.district_id = {'_eq': value.value};
                    break;
                  case 'id_ward_key':
                    where.ward_id = {'_eq': value.value};
                    break;
                  case 'code_agency_tpl':
                    //console.log("value.valuevalue.value:",value.value)
                    where.code_agency = {'_eq': value.value};
                    break;
                  default:
                    where[key] =  {'_eq': value.value};
                }
                break;
              case 'MultiSelect':
                /*if (key == 'selected_organization_filter'){
                  if (value.value.length > 0){
                    if (this.$myConstants.isEmpty(where['request_activation'])){
                      where['request_activation'] = {};
                    }
                    where['request_activation']["organization_id"] = {_in: value.value}
                  }
                }
                else if (key == 'selected_province_filter'){
                  if (value.value.length > 0){
                    if (this.$myConstants.isEmpty(where['request_activation'])){
                      where['request_activation'] = {};
                    }
                    where['request_activation']["organizations"] = {province_id: {_in: value.value}}
                  }
                }
                else if (key == 'selected_category_filter'){
                  if (value.value.length > 0){
                    if (this.$myConstants.isEmpty(where['product_serial_number'])){
                      where['product_serial_number'] = {};
                    }
                    where['product_serial_number']["product"] =  {category_id: {_in: value.value}}
                  }
                }
                else if (key == 'selected_product_filter'){
                  if (value.value.length > 0){
                    if (this.$myConstants.isEmpty(where['product_serial_number'])){
                      where['product_serial_number'] = {};
                    }
                    where['product_serial_number']["product_id"] =   {_in: value.value}
                  }
                }
                else if (key == 'selected_warranty_status_filter'){
                  if (value.value.length > 0){
                    dataFilterStatus = value.value;
                    var list_status = vm.$myConstants.convertJsonObject(value.value);
                    if (list_status.indexOf(0) > -1){
                      list_status.push(5);//trang thái chưa kích hoạt có 2 key nên gán thêm key
                    }
                    if (list_status.indexOf(3) > -1){
                      list_status.push(1);//trang thái đã kích hoạt có 2 key nên gán thêm key
                    }
                    where['warranty_status'] =   {_in: list_status}
                  }
                }*/
                //organizations: {province_id: {_in: 10}}}
                console.log("value.value:",value.value)
                /*if(value.value !== undefined && value.value !== null){
                  where[key] = {'_gte': value.value.from,'_lte': value.value.to}
                }*/
                break;
              default:
                // code block
            }
          }
        }
      }
      var variables = {
        where_key: where,
        offset:offset,
        limit:limit,
        orderBy: [
          {id: 'desc'},
          // {parts_number: 'desc'}
        ]
      }
      this.where_filter = where;
      //console.log(variables);
      //this.$emit('filterExport',variables)//truyền query
      var data_list = await this.$CoreService.getListVar('list_document',variables);
      var list = [];
      if (!this.$commonFuction.isEmpty(data_list.document)){
        list = data_list.document;
      }
      var variablesCountTotal = {
        where_key: where,
        /*offset:offset,
        limit:limit,
        orderBy: [
          {id: 'desc'},
          // {parts_number: 'desc'}
        ]*/
      }
      var countTotal = await this.$CoreService.countRecordListDocs('list_document',variablesCountTotal);
      var total = 0;
      var total_price = 0;
      if (!this.$commonFuction.isEmpty(countTotal.document_aggregate)){
        if (!this.$commonFuction.isEmpty(countTotal.document_aggregate.aggregate)){
          if (!this.$commonFuction.isEmpty(countTotal.document_aggregate.aggregate.count)){
            total = countTotal.document_aggregate.aggregate.count;
          }
          if (!this.$commonFuction.isEmpty(countTotal.document_aggregate.aggregate.sum)){
            total_price = countTotal.document_aggregate.aggregate.sum.cost_document;
          }
        }
      }
      //console.log("countTotalcountTotal:",countTotal);
      //console.log("listlistlist:",list);
      // console.log("data_listdata_listdata_list:",data_list);
      /*var data = await DataServices.getList(modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];*/
      /*var variablesCount = {
        where_key: where
      }
      var name_aggregate = 'view_request_activation_product_aggregate';
      var countDataQuery = await DataServices.countData(modelName, {"variables": JSON.stringify(variablesCount)});
      var total = countDataQuery[name_aggregate]['aggregate']['count'];*/


      var dataRes = {
        listData: list,
        total: total,
        total_price: total_price,
      };
      this.$store.commit('setLoading', false);
      //  console.log('dataRes:',dataRes);
      return dataRes;
    },
    async onFilter(event,type_input,key) {
console.log("this.filters.id_district_key",this.filters)
      if (key == 'state_id'){
       // this.filters["id_district_key"] = null;
       // this.filters["id_ward_key"] = null;
        if (!this.$commonFuction.isEmpty(event.value)){
          this.list_dictrict_filter =await this.$CoreService.getDistrictByIdState(event.value);
        }else {
          this.list_dictrict_filter = [];
        }
        this.list_ward_filter = [];
        this.list_ward_filter =await this.$CoreService.getWardByIdDistrict(null,event.value);
        

       // this.filters.id_district_key = null;//clear filter
       // this.filters.id_ward_key = null;
      }else if (key == 'id_district_key'){
       // this.filters.id_ward_key = null;
        if (!this.$commonFuction.isEmpty(event.value)){
          this.list_ward_filter = [];
          this.list_ward_filter =await this.$CoreService.getWardByIdDistrict(event.value);
        }else {
          this.list_ward_filter = [];
        }
      }

      this.filtersCustom[key] = await this.$CoreService.convertFilter(type_input,key,this.filters);
      //this.lazyParams.first = 0;
      //this.onLazyEvent()
    },
    async onFilterData() {
      /* this.filtersCustom[key] = await this.$CoreService.convertFilter(type_input,key,this.filters);
       this.lazyParams.first = 0;*/
      this.onLazyEvent()
    },
    async clearFilterData() {
      this.filtersCustom = [];
      this.filters = {};
      this.onLazyEvent()
    },
    sortTable(event) {
      console.log("eventevent:",event)
      var sortby = 'asc'
      this.orderBy = {}
      if(event.sortOrder == -1){
        sortby = 'desc'
      }
      //if (event.sortField == 'created_at'){
      //Nếu ngày tạo thì sort id chính xác hơn
      this.orderBy[event.sortField] = sortby
      // }
      this.lazyParams.first = 0;
      this.onLazyEvent()
    },
    async popupDeleteDosc() {
      this.displayDialog = true
      this.editDialogKey = Math.floor(Math.random() * (30))
    }
  },
  /* apollo: {
     listData: {
       query() {
         this.modelName = this.$route.meta.model;
         return DataServices.getList(this.modelName);
       },
       variables: {
         where_key: {
           status_document: {
             // code: {'_neq': "WAITING"},
             deleted: {'_eq': false}
           },
           deleted: {'_eq': false}
         },
         orderBy: {id: 'desc'}
       },
       update(data) {
         var listData = data[this.dataModel.tableName]
         this.title = this.dataModel.label + ' '
         this.dataModel.processData(listData)
         this.$store.commit('setLoading', false);
         this.componentKey += 1
         // this.totalDoc = data.document.length;
         return data[this.dataModel.tableName]
       },
       fetchPolicy: 'network-only',
       error() {
         this.$store.commit('setLoading', false);
       },
       skip() {
         return !this.modelName
       }
     }
   }*/

}
</script>
<style lang="scss">
.p-datepicker { top: 0px !important;}
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.doc-header {
  &.doc-title {
    color: #1D3118;
    text-transform: capitalize;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
  }
}
.export-barcode {
  margin-left: 24px !important;
  background-color: #0A84FF;
}
.box-selected-file {
  // padding: 10px;
  position: relative;
  width: fit-content;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  input.file {position: absolute; opacity: 0;cursor: pointer;}
}
.box-selected-file span {
  padding: 7px 15px;
  background: #0A84FF 0% 0% no-repeat padding-box;
  border: 1px solid #0A84FF;
  border-radius: 3px;
  cursor: pointer;
  font-size: 0.875rem;
  color: #ffffff;
}
.row-warning {
  color: orange !important;
}
.row-error {
  color: red !important;
}
.p-column-filter {
  .p-dropdown-label {
    &.p-inputtext {
      width: 40px;
      text-transform: unset;
    }
  }
}
.style-btn-header{
  margin: 0px 2px;
  padding: 5px 5px;
}
.delete_multiple_docs{
  color: #ffffff !important;
  background: #ffba01 !important;
  border: 1px solid #ffba01 !important;
}
</style>